import { addOptionalMessage } from 'owa-locstrings/lib/strings/addoptionalmessage.locstring.json';
import {
    meetingRequestSeriesEditorTitle,
    meetingRequestEditorTitle,
    notifyOrganiserLabel_0,
} from './MeetingRequestResponseEditor.locstring.json';
import loc, { format } from 'owa-localize';
import MeetingRequestActions from './MeetingRequestActions';
import onNotifyOrganiserToggled from '../actions/onNotifyOrganiserToggled';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { AriaRoles } from 'owa-accessibility';
import { ControlIcons } from 'owa-control-icons';
import ReactEditor from 'owa-editor/lib/components/ReactEditor';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import UpdateResponseButton from './UpdateResponseButton';
import shouldShowResponseActions from '../utils/shouldShowResponseActions';

import * as React from 'react';

const classNames = require('classnames');
const styles = require('./MeetingRequestInfo.scss');

export interface MeetingRequestResponseEditorProps {
    item: MeetingRequestMessageType;
    viewState: MeetingRequestViewState;
    entrySource: MeetingMessageActionEntrySource;
    onActionButtonClicked?: () => void;
    editorClassName?: string;
    treatAsInThePast?: boolean;
}

@observer
export default class MeetingRequestResponseEditor extends React.Component<
    MeetingRequestResponseEditorProps,
    {}
> {
    render() {
        if (shouldShowResponseActions(this.props.viewState)) {
            return this.renderResponseEditor();
        } else {
            return (
                <UpdateResponseButton
                    viewState={this.props.viewState}
                    showDisabledUI={this.props.treatAsInThePast}
                    disableInteraction={!this.props.item}
                />
            );
        }
    }

    private renderResponseEditor() {
        const { item, viewState, entrySource, onActionButtonClicked, editorClassName } = this.props;
        const title =
            item.CalendarItemType === 'RecurringMaster'
                ? loc(meetingRequestSeriesEditorTitle)
                : loc(meetingRequestEditorTitle);

        return (
            <>
                {item.IsResponseRequested && (
                    <div aria-label={title} role={AriaRoles.form}>
                        <div className={styles.editorAndNotifyToggle}>
                            <div className={styles.editorTitleRow}>
                                <Icon
                                    iconName={ControlIcons.CalendarReply}
                                    className={styles.icon}
                                />
                                <span className={styles.editorLabel}>{title}</span>
                            </div>

                            <div className={styles.toggleContainer}>
                                <Label className={classNames(styles.toggleLabel)}>
                                    {loc(notifyOrganiserLabel_0)}
                                </Label>
                                <Toggle
                                    className={styles.toggle}
                                    defaultChecked={true}
                                    label={null}
                                    ariaLabel={loc(notifyOrganiserLabel_0)}
                                    checked={viewState.editorViewState.sendResponse}
                                    onChange={this.onToggleNotify}
                                />
                            </div>
                        </div>
                        {this.props.viewState.editorViewState.sendResponse ? (
                            <ReactEditor
                                viewState={viewState.editorViewState}
                                watermark={format(
                                    loc(addOptionalMessage),
                                    item.Organizer.Mailbox.Name
                                )}
                                classNames={classNames(styles.editor, editorClassName)}
                                updateOnKeyPress={true}
                                isDarkMode={isFeatureEnabled('cmp-darkMode') && getIsDarkTheme()}
                            />
                        ) : (
                            <textarea className={styles.disabledEditor} disabled={true}>
                                {format(loc(addOptionalMessage), item.Organizer.Mailbox.Name)}
                            </textarea>
                        )}
                    </div>
                )}
                <MeetingRequestActions
                    item={item}
                    viewState={viewState}
                    entrySource={entrySource}
                    onActionButtonClicked={onActionButtonClicked}
                />
            </>
        );
    }

    private onToggleNotify = (evt: React.MouseEvent<HTMLElement>, sendResponse: boolean) => {
        evt.stopPropagation();
        onNotifyOrganiserToggled(this.props.viewState, sendResponse);
    };
}
